package rendering

import ext.set
import three.js.AmbientLight
import three.js.DirectionalLight
import three.js.Scene

object SceneManager {
    private val followCameraLight = DirectionalLight(0xfff5fe, 1.5).apply { position.set(1000, 2000, 4000) }

    val scene = Scene().apply {
        add(DirectionalLight(0xeee5e5, 1.4).apply { position.set(-1000, 2000, 4000) })
        add(AmbientLight(0xdeefef, 1.4))
//        add(AmbientLight(0xf6cd8b, 1.5))
        add(DirectionalLight(0xeef5f5, 1.4).apply { position.set(-500, 2000, -4000) })

        add(followCameraLight)
//        add(AmbientLight(0xf6cd8b, 5))
    }

    fun updateCameraLightPosition() {
        followCameraLight.position.set(CameraManager.camera.position)
    }
}